export function getEventPageName(pageName?: string): string {
    const cleanedName =
        pageName?.replace(/^\/|\/$/g, '').replace(/\//g, '_') || 'NA';

    const eventName = `${cleanedName
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join('_')}`;

    return eventName;
}
